import * as moment from 'moment';
import { Moment } from 'moment';
import { Booking } from '../models/booking';
import { Segment } from '../models/segment';
import { Money } from '../models/money';
import { Passenger } from '../models/passenger';
import { Voucher } from '../models/voucher';
import { APILoginRequest, APIRedeemVoucherRequest, APISendVoucherRequest } from './api';
import { APIBooking, APIEmail, APISegment, APIMoney, APIPassenger, APIVoucher } from './protocol';
import { Email } from '../models/email';

export function marshalLoginRequest(pnr: string, lastName: string): APILoginRequest {
  return {
    pnr,
    last_name: lastName,
  };
}

export function marshalRedeemVoucherRequest(pnr: string, lastName: string,
                                            passenger: Passenger): APIRedeemVoucherRequest {
  return {
    pnr,
    last_name: lastName,
    passenger_id: passenger.id,
  };
}

export function marshalSendVoucherRequest(toAddress: string, pnr: string, lastName: string,
                                          passenger: Passenger): APISendVoucherRequest {
  return {
    pnr,
    to_address: toAddress,
    last_name: lastName,
    passenger_id: passenger.id,
  };
}

export function unmarshalBooking(booking: APIBooking): Booking {
  return {
    segment: unmarshalSegment(booking.segment),
    passengers: booking.passengers.map(unmarshalPassenger),
    pnr: booking.pnr,
    contactFirstName: booking.contact_first_name,
    contactLastName: booking.contact_last_name,
    contactEmail: booking.contact_email,
  };
}

function unmarshalSegment(segment: APISegment): Segment {
  return new Segment(
    segment.carrier_code,
    Number(segment.flight_number),
    unmarshalDateTime(segment.departure_date),
    unmarshalDateTime(segment.departure_utc),
    unmarshalDateTime(segment.arrival_utc),
    unmarshalDateTime(segment.departure_local),
    unmarshalDateTime(segment.arrival_local),
    segment.origin_code,
    segment.destination_code,
    moment.duration(segment.delay_minutes, 'minutes'),
    segment.operated_by,
    segment.delay_code,
  );
}

export function unmarshalPassenger(passenger: APIPassenger): Passenger {
  return {
    id: passenger.id,
    firstName: passenger.first_name,
    lastName: passenger.last_name,
    fareBasisCode: passenger.fare_basis_code,
    ageCategory: passenger.age_category,
    isPrimaryContact: passenger.is_primary_contact,
    voucher: passenger.voucher && unmarshalVoucher(passenger.voucher),
    shouldShowExpiredMessage: passenger.should_show_expired_message,
  };
}

export function unmarshalVoucher(data: APIVoucher): Voucher {
  return {
    amount: unmarshalMoney(data.amount),
    reference: data.reference,
    created_at: unmarshalDateTime(data.created_at),
    emails: data.emails ? data.emails.map(unmarshalEmail) : [],
  };
}

function unmarshalMoney(data: APIMoney): Money {
  return new Money(data.amount, data.currency_code);
}

function unmarshalDateTime(blob: string): Moment {
  return moment.parseZone(blob, moment.ISO_8601, true);
}

function unmarshalEmail(data: APIEmail): Email {
  return {
    fromAddress: data.from_address,
    toAddress: data.to_address,
    sentAt: unmarshalDateTime(data.sent_at),
  };
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/api/marshal.ts